import { markRaw as a } from "vue";
import { CircleClose as r } from "./index537.js";
import { mutable as p } from "./index612.js";
import { iconPropType as o } from "./index606.js";
import { useSizeProp as l } from "./index607.js";
import { UPDATE_MODEL_EVENT as s } from "./index584.js";
import { buildProps as u, definePropType as t } from "./index601.js";
import { useAriaProps as f } from "./index650.js";
import { isString as i } from "./index575.js";
const P = u({
  /**
   * @description native input id
   */
  id: {
    type: String,
    default: void 0
  },
  /**
   * @description input box size
   */
  size: l,
  /**
   * @description whether to disable
   */
  disabled: {
    type: Boolean,
    default: void 0
  },
  /**
   * @description binding value
   */
  modelValue: {
    type: t([
      String,
      Number,
      Object
    ]),
    default: ""
  },
  /**
   * @description v-model modifiers, reference [Vue modifiers](https://vuejs.org/guide/essentials/forms.html#modifiers)
   */
  modelModifiers: {
    type: t(Object),
    default: () => ({})
  },
  /**
   * @description same as `maxlength` in native input
   */
  maxlength: {
    type: [String, Number]
  },
  /**
   * @description same as `minlength` in native input
   */
  minlength: {
    type: [String, Number]
  },
  /**
   * @description type of input, see more in [MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types)
   */
  type: {
    type: t(String),
    default: "text"
  },
  /**
   * @description control the resizability
   */
  resize: {
    type: String,
    values: ["none", "both", "horizontal", "vertical"]
  },
  /**
   * @description whether textarea has an adaptive height
   */
  autosize: {
    type: t([Boolean, Object]),
    default: !1
  },
  /**
   * @description native input autocomplete
   */
  autocomplete: {
    type: t(String),
    default: "off"
  },
  /**
   * @description format content
   */
  formatter: {
    type: Function
  },
  /**
   * @description parse content
   */
  parser: {
    type: Function
  },
  /**
   * @description placeholder
   */
  placeholder: {
    type: String
  },
  /**
   * @description native input form
   */
  form: {
    type: String
  },
  /**
   * @description native input readonly
   */
  readonly: Boolean,
  /**
   * @description whether to show clear button
   */
  clearable: Boolean,
  /**
   * @description custom clear icon component
   */
  clearIcon: {
    type: o,
    default: r
  },
  /**
   * @description toggleable password input
   */
  showPassword: Boolean,
  /**
   * @description word count
   */
  showWordLimit: Boolean,
  /**
   * @description word count position, valid when `show-word-limit` is true
   */
  wordLimitPosition: {
    type: String,
    values: ["inside", "outside"],
    default: "inside"
  },
  /**
   * @description suffix icon
   */
  suffixIcon: {
    type: o
  },
  /**
   * @description prefix icon
   */
  prefixIcon: {
    type: o
  },
  /**
   * @description container role, internal properties provided for use by the picker component
   */
  containerRole: {
    type: String,
    default: void 0
  },
  /**
   * @description input tabindex
   */
  tabindex: {
    type: [String, Number],
    default: 0
  },
  /**
   * @description whether to trigger form validation
   */
  validateEvent: {
    type: Boolean,
    default: !0
  },
  /**
   * @description input or textarea element style
   */
  inputStyle: {
    type: t([Object, Array, String]),
    default: () => p({})
  },
  /**
   * @description native input autofocus
   */
  autofocus: Boolean,
  rows: {
    type: Number,
    default: 2
  },
  ...f(["ariaLabel"]),
  /**
   * @description native input mode for virtual keyboards
   */
  inputmode: {
    type: t(String),
    default: void 0
  },
  /**
   * @description same as `name` in native input
   */
  name: String
}), h = {
  [s]: (e) => i(e),
  input: (e) => i(e),
  change: (e, n) => i(e) && (n instanceof Event || n === void 0),
  focus: (e) => e instanceof FocusEvent,
  blur: (e) => e instanceof FocusEvent,
  clear: () => !0,
  mouseleave: (e) => e instanceof MouseEvent,
  mouseenter: (e) => e instanceof MouseEvent,
  // NOTE: when autofill by browser, the keydown event is instanceof Event, not KeyboardEvent
  // relative bug report https://github.com/element-plus/element-plus/issues/6665
  keydown: (e) => e instanceof Event,
  compositionstart: (e) => e instanceof CompositionEvent,
  compositionupdate: (e) => e instanceof CompositionEvent,
  compositionend: (e) => e instanceof CompositionEvent
};
a(r);
export {
  h as inputEmits,
  P as inputProps
};
